import { createContext } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiYW50b255bWFjaWVsIiwiYSI6ImNrODR1Y2F6aTAwNDAzZHJxMmR3czRkbmoifQ.dJkHL1pc1aNAtVADQS8_jw';

export const CategorizedContentStoreContext = createContext();
